var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lp-base",class:("lp-base--" + _vm.lpId)},[_c(_vm.targetComp,{tag:"component",attrs:{"lp-id":_vm.lpId,"target-info":_vm.targetInformation,"color-scheme":_vm.targetColorScheme,"token":_vm.token}}),_vm._v(" "),_c('lp-footer',{attrs:{"color-scheme":_vm.targetColorScheme,"menu-list":_vm.footerMenuList,"lp-id":_vm.lpId}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-199475b5","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/utvStore/components/recommend/lp/RecommendBasicInputManager.vue
// module id = null
// module chunks = 